export default class AppCalendar {
    eventRender (calEvent, element) {
        let today = moment.utc(new Date().getTime());
        let start = moment.utc(calEvent.start);
        let end = moment.utc(calEvent.end ? calEvent.end : calEvent.start);

        if (start.isBefore(today, 'day') && end.isBefore(today, 'day')) {
            element.addClass('past');
        } else if (start.isSameOrBefore(today, 'day') && end.isSameOrAfter(today, 'day')) {
            element.addClass('today');
        } else if (start.isAfter(today, 'day') && end.isAfter(today, 'day')) {
            element.addClass('future');
        }
    }

    eventAfterAllRender (view) {
        if (view.el.hasClass('fc-month-view')) {
            let $container = view.el.find('.fc-day-grid-container');
            $container.css('height', 'auto');
            $container.find('.fc-week').css('height', 'auto');
        }
    }
}



// WEBPACK FOOTER //
// ./resources/assets/js/components/calendar.js